import * as v from "valibot";
import { rpcContract } from "../rpc";
import { DONATION_MAX_CENTS, DONATION_MIN_CENTS } from "../donation-validators";

/**
 * Create a Stripe Checkout Session for a one-off donation on a live event.
 *
 * Bounds mirror the shared donation-validators constants so the DB CHECK,
 * client UI, and contract all enforce the same floor/ceiling. See
 * `donation-validators.ts` for the canonical numbers.
 */
export const createDonationCheckoutRpcContract = rpcContract({
  name: "create-donation-checkout",
  paramsSchema: v.object({
    liveEventId: v.pipe(v.string(), v.uuid("liveEventId must be a UUID")),
    amountCents: v.pipe(
      v.number(),
      v.integer("amountCents must be an integer"),
      v.minValue(DONATION_MIN_CENTS, `Amount must be at least ${DONATION_MIN_CENTS} cents (€0.50)`),
      v.maxValue(DONATION_MAX_CENTS, `Amount cannot exceed ${DONATION_MAX_CENTS} cents (€99,999)`),
    ),
    returnUrl: v.optional(v.string()),
  }),
  resultSchema: v.object({
    sessionId: v.string(),
    url: v.string(),
  }),
});

export type CreateDonationCheckoutParams = v.InferOutput<(typeof createDonationCheckoutRpcContract)["paramsSchema"]>;
export type CreateDonationCheckoutResult = v.InferOutput<(typeof createDonationCheckoutRpcContract)["resultSchema"]>;
